import axios from 'axios';

// Track if we're currently loading CollectJS
let isLoadingCollectJS = false;
let loadingPromise = null;

export default function injectCollectJS(collectJsUrl, tokenizationKey, checkoutCallback, price) {
    // If already loading, wait for it to complete first
    if (isLoadingCollectJS && loadingPromise) {
        return loadingPromise.then(() => {
            // After previous load completes, reinitialize with new price
            return injectCollectJS(collectJsUrl, tokenizationKey, checkoutCallback, price);
        });
    }
    
    isLoadingCollectJS = true;
    loadingPromise = new Promise((resolve, reject) => {
        try {
            // Clear existing payment buttons
            const applePayButton = document.getElementById('applepaybutton');
            const googlePayButton = document.getElementById('googlepaybutton');
            if (applePayButton && applePayButton.innerHTML !== '') {
                applePayButton.innerHTML = '';
            }
            if (googlePayButton && googlePayButton.innerHTML !== '') {
                googlePayButton.innerHTML = '';
            }
            // Remove existing CollectJS scripts
            const existingScripts = document.querySelectorAll(`script[src*="nmi.com"]`);
            if (existingScripts.length > 0) {
                existingScripts.forEach(script => {
                    try {
                        script.remove();
                    } catch (e) {
                        console.warn('Could not remove script:', e);
                    }
                });
                
                // Wait a bit for cleanup to complete
                setTimeout(() => loadNewScript(), 100);
            } else {
                // No existing scripts, load immediately
                loadNewScript();
            }
            
            function loadNewScript() {
                // Don't try to delete window.CollectJS as it might cause issues
                // Let the new script overwrite it
                
                // Create fresh script with timestamp to force reload
                const script = document.createElement('script');
                const timestamp = Date.now();
                script.setAttribute('src', `${collectJsUrl}?t=${timestamp}`);
                script.setAttribute('data-tokenization-key', tokenizationKey);
                script.setAttribute('data-variant', 'inline');
                script.setAttribute('data-currency', 'USD');
                script.setAttribute('data-country', 'US');
                script.setAttribute('data-price', price);
                
                script.onload = function() {
                    try {
                        // Wait a moment for CollectJS to initialize
                        setTimeout(() => {
                            if (window.CollectJS) {
                                const collectInstance = window.CollectJS;
                                
                                // Configure CollectJS with your options
                                collectInstance.configure({
                                    callback: function(response) {
                                        console.log('CollectJS callback:', response);
                                        checkoutCallback(response.token, response.wallet?.cardDetails || null);
                                    },
                                    validationCallback: function(fieldName, valid, message) {
                                        if (!valid) {
                                            console.error(`Field ${fieldName} error: ${message}`);
                                        }
                                    }
                                });
                                
                                isLoadingCollectJS = false;
                                resolve(window.CollectJS);
                            } else {
                                console.error('CollectJS not available after script load');
                                isLoadingCollectJS = false;
                                reject(new Error('CollectJS not available'));
                            }
                        }, 100);
                    } catch (error) {
                        console.error('Error configuring CollectJS:', error);
                        isLoadingCollectJS = false;
                        reject(error);
                    }
                };
                
                script.onerror = function(error) {
                    console.error('Failed to load CollectJS script:', error);
                    isLoadingCollectJS = false;
                    reject(new Error('Failed to load CollectJS script'));
                };
                
                // Add error event listener to catch any script errors
                script.addEventListener('error', (e) => {
                    console.error('Script error event:', e);
                });
                
                document.body.appendChild(script);
            }
        } catch (error) {
            console.error('Error in CollectJS initialization:', error);
            isLoadingCollectJS = false;
            reject(error);
        }
    });
    
    return loadingPromise;
}